var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.500977,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 3.5,
    fill: "#E7E7E7",
    stroke: "#E7E7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.001 13C19.1999 13 19.3907 13.079 19.5313 13.2197C19.672 13.3603 19.751 13.5511 19.751 13.75V18.25H24.251C24.4499 18.25 24.6407 18.329 24.7813 18.4697C24.922 18.6103 25.001 18.8011 25.001 19C25.001 19.1989 24.922 19.3897 24.7813 19.5303C24.6407 19.671 24.4499 19.75 24.251 19.75H19.751V24.25C19.751 24.4489 19.672 24.6397 19.5313 24.7803C19.3907 24.921 19.1999 25 19.001 25C18.8021 25 18.6113 24.921 18.4706 24.7803C18.33 24.6397 18.251 24.4489 18.251 24.25V19.75H13.751C13.5521 19.75 13.3613 19.671 13.2206 19.5303C13.08 19.3897 13.001 19.1989 13.001 19C13.001 18.8011 13.08 18.6103 13.2206 18.4697C13.3613 18.329 13.5521 18.25 13.751 18.25H18.251V13.75C18.251 13.5511 18.33 13.3603 18.4706 13.2197C18.6113 13.079 18.8021 13 19.001 13Z",
    fill: "#005BA9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.dc1f32fcf64b7adfdf567dad390c86fa.svg";
export { ForwardRef as ReactComponent };